import * as React from 'react';
import { Button } from '@ai-content-hub/content-kit';
import { X } from 'lucide-react';
import type { UploadedDocument } from '../types';
import { usePromptTranslations } from '../i18n';

export interface DocumentListProps {
    documents: UploadedDocument[];
    onRemove: (id: string) => void;
    disabled?: boolean;
}

export const DocumentList: React.FC<DocumentListProps> = ({
    documents,
    onRemove,
    disabled = false,
}) => {
    if (documents.length === 0) return null;
    const pt = usePromptTranslations();

    return (
        <div className="prompt-description-document-list flex flex-col gap-2 mt-2">
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {pt.uploadedDocuments}
            </span>
            <ul className="flex flex-col gap-1.5 rounded-sm bg-muted/30 p-2 border border-border">
                {documents.map((doc) => (
                    <li
                        key={doc.id}
                        className="flex items-center justify-between gap-2 py-1.5 px-2 rounded-sm hover:bg-muted/50"
                    >
                        <span className="text-sm text-foreground truncate flex-1">{doc.name}</span>
                        <Button
                            type="button"
                            variant="ghost"
                            size="icon-sm"
                            onClick={() => onRemove(doc.id)}
                            disabled={disabled}
                            className="shrink-0 text-muted-foreground hover:text-destructive hover:bg-destructive/10"
                            title={pt.removeDocument}
                        >
                            <X className="h-4 w-4" />
                        </Button>
                    </li>
                ))}
            </ul>
        </div>
    );
};
